import request from '@/plugin/axios'

// 分享时调用
export function posterSharingSharing(data) {
    return request({
        url: '/api/posterSharing/sharing',
        method: 'post',
        data
    })
}
// 进来就调用
export function queryPoster(data) {
    return request({
        url: '/api/posterSharing/queryPoster',
        method: 'post',
        data
    })
}
export function upload(file) {
    return request({
        url: `/api/_admin/upload/poster`,
        method: 'post',
        data: file
    })
}
export function uploadBase64(base64) {
    return request({
        url: `/api/_admin/uploadBase64/poster`,
        method: 'post',
        data: { base64 }
    })
}

export function genTicket(data) {
    return request({
        url: '/api/posterSharing/genTicket',
        method: 'post',
        data
    })
}